import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
  Grid,
  TextField,
  OutlinedInput,
  Button,
} from "@mui/material";
import React from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import { useForm, Controller } from "react-hook-form";
import humbbleIcon from "../../../assets/AccountingModule/humbleicons_upload.svg";
import { computationTypeOptions, depreciationFrequencyOptions } from "../../../constants/data";

const OrganizeProfilePage = ({ loading, handleAddNewCustomer }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const onSubmit = (data) => {
    handleAddNewCustomer(data);
  };

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Organization Profile</Typography>
        </Box>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <Box sx={style.container}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={style.field}>
                    <Typography sx={style.label}>Organization Name</Typography>
                    <Controller
                      name="description"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <OutlinedInput
                            {...field}
                            fullWidth
                            multiline
                            sx={style.textField}
                            placeholder="Enter Organization Name"
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={style.field}>
                    <Typography sx={style.label}>Industry</Typography>
                    <Controller
                      name="industry"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Select
                            {...field}
                            fullWidth
                            displayEmpty
                            size="small"
                            sx={style.textField}
                            defaultValue=""
                          >
                            <MenuItem value="">
                              <span style={{ color: "#999" }}>Select Industry</span>
                            </MenuItem>
                            {computationTypeOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={style.field}>
                    <Typography sx={style.label}>Organization Location</Typography>
                    <Controller
                      name="depreciationFrequency"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Select
                            {...field}
                            fullWidth
                            displayEmpty
                            size="small"
                            sx={style.textField}
                            defaultValue=""
                          >
                            <MenuItem value="">
                              <span style={{ color: "#999" }}>Select Depreciation Frequency</span>
                            </MenuItem>
                            {depreciationFrequencyOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ ...style.container, }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ ...style.fileBox, height: "100%" }}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                    Attach File to Quote
                  </Typography>
                  <Box
                    sx={{
                      ...style.fileDropArea,
                      border: "2px dashed #ccc",
                      borderRadius: "8px !important",
                      p: 2,
                      minHeight: "76px",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "white",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: "#28AA4A",
                      },
                    }}
                  >
                    <input
                      type="file"
                      id="quoteFileUpload"
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="quoteFileUpload"
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column"
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                        <Button
                          variant="contained"
                          component="span"
                          startIcon={
                            <Box
                              component="span"
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={humbbleIcon}
                                alt="Upload"
                                style={{ width: "16px", height: "16px" }}
                              />
                            </Box>
                          }
                          sx={{
                            backgroundColor: "#28AA4A",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center", // <-- icon center
                            "&:hover": {
                              backgroundColor: "#229A41",
                            },
                          }}
                        >
                        </Button>
                        <Typography sx={{ color: "#666", fontSize: "12px", fontWeight: "400" }}>
                          Upload Your Organization Logo
                        </Typography>
                      </Box>
                      {/* )} */}
                    </label>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "10px", color: "#666", mt: 1, textAlign: "center" }}>
                      Preferred Image Dimensions: 240 x 240 pixels @ 72 DPI <br />
                      Supported Files: jpg, jpeg, png, gif, bmp <br />
                      Maximum File Size: 1MB
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Box px="15px" mt={2}>
          <Box sx={style.headerContainer}>
            <Typography sx={style.leaveHeading}>Address</Typography>
          </Box>
        </Box>
        <Grid container>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.addressBox}>
              <Box sx={{ width: "50%" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Address</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <Controller
                      name="billingStreet1"
                      control={control}
                      rules={{ required: "Street 1 is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="Street 1"
                            sx={style.addressTextField}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                            }}
                            error={!!error}
                            helperText={error?.message}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                    <Controller
                      name="billingStreet2"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="Street 2"
                            sx={{ ...style.addressTextField, mt: 3 }}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                            }}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Box>

                {/* City */}
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>City</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <Controller
                      name="billingCity"
                      control={control}
                      rules={{ required: "City is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="City"
                            sx={style.addressTextField}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                            }}
                            error={!!error}
                            helperText={error?.message}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Box>

                {/* State */}
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>State</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <Controller
                      name="billingState"
                      control={control}
                      rules={{ required: "State is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="State"
                            sx={style.addressTextField}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                            }}
                            error={!!error}
                            helperText={error?.message}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Box>

                {/* Pin Code */}
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Pin Code</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <Controller
                      name="billingPinCode"
                      control={control}
                      rules={{ required: "Pin Code is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="Pin Code"
                            sx={style.addressTextField}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                            }}
                            error={!!error}
                            helperText={error?.message}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Box>

                {/* Phone */}
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Phone</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <Controller
                      name="billingPhone"
                      control={control}
                      rules={{
                        required: "Phone is required",
                        pattern: { value: /^[0-9]+$/, message: "Only numbers allowed" },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth
                            placeholder="Phone"
                            sx={style.addressTextField}
                            InputProps={{
                              sx: { fontSize: "14px", fontWeight: 400 },
                              inputProps: { pattern: "[0-9]*", inputMode: "numeric" },
                            }}
                            error={!!error}
                            helperText={error?.message}
                          />
                          {error && (
                            <Typography sx={style.errorText}>
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <LoadingButton
              loading={loading}
              variant="contained"
              type="submit"
              color="success"
              sx={{ ...style.jobButtons, mb: 3 }}
            >
              Save
            </LoadingButton>
          </Box>
          <Box sx={style.createJob}>
            <Button
              variant="contained"
              color="error"
              sx={{ ...style.cancelButtons, mb: 3 }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </form >
    </>
  );
};

export default OrganizeProfilePage;
